import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=26e914eb&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26e914eb')) {
      api.createRecord('26e914eb', component.options)
    } else {
      api.reload('26e914eb', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=26e914eb&", function () {
      api.rerender('26e914eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2s926vMQ3rgmH/JS/comp/IncreaseNumber.vue"
export default component.exports